import { z } from 'zod';

// Form
const SeveritySchema = z.enum(['success', 'info', 'warning', 'error']);

export const NotificationFormSchema = z.object({
  title: z.string(),
  message: z.string(),
  // severity: z.string(),
  severity: SeveritySchema,
  showIcon: z.boolean(),
  dateTime: z.string(),
});

export type NotificationForm = z.infer<typeof NotificationFormSchema>;

// Backend response
export const NotificationSchema = z.object({
  _id: z.string(),
  createdAt: z.string(),
  title: z.string(),
  message: z.string(),
  severity: SeveritySchema,
  showIcon: z.boolean(),
  dateTime: z.string(),
});
export type NotificationType = z.infer<typeof NotificationSchema>;

export const NotificationsSchema = NotificationSchema.array();
export type Notifications = z.infer<typeof NotificationsSchema>;

// Get
export type GetNotificationRequest = string;
export type GetNotificationResponse = NotificationType;
export const GetNotificationResponseSchema = NotificationSchema;

// List
export type ListNotificationsRequest = void;
export type ListNotificationsResponse = Notifications;
export const ListNotificationsResponseSchema = NotificationsSchema;

// Create
export type CreateNotificationRequest = NotificationForm;
export type CreateNotificationResponse = NotificationType;
export const CreateNotificationResponseSchema = NotificationSchema;

// Edit
export interface EditNotificationRequest extends NotificationForm {
  notificationId: string;
}
export type EditNotificationResponse = NotificationType;
export const EditNotificationResponseSchema = NotificationSchema;

// Delete
export type DeleteNotificationRequest = string;
export const DeleteNotificationResponseSchema = z.object({
  message: z.string(),
});
export type DeleteNotificationResponse = z.infer<
  typeof DeleteNotificationResponseSchema
>;

// Close
export interface CloseNotificationRequest {
  notificationId: string;
  userId: string;
}
export const CloseNotificationResponseSchema = DeleteNotificationResponseSchema;
export type CloseNotificationResponse = DeleteNotificationResponse;
